import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import socialPlatformOptions from "../utils/socialPlatformOptions";
import getLabels from "../utils/getLabels";

export default function SocialPlatformTags({
  selectedPlatformValues,
  setSelectedPlatformValues,
  isExpandable,
  children,
  hiddenPlatforms = [],
}) {
  const socialPlatformLabels = getLabels(
    socialPlatformOptions.filter(
      (item) => !hiddenPlatforms.includes(item.value),
    ),
  );

  const handleSetPlatform = (platformLabel) => {
    const foundPlatformOption = socialPlatformOptions.find(
      (option) => option.label === platformLabel,
    );
    if (foundPlatformOption) {
      setSelectedPlatformValues([
        ...selectedPlatformValues,
        foundPlatformOption.value,
      ]);
    }
  };

  const handleUnsetPlatform = (platformLabel) => {
    const foundPlatformOption = socialPlatformOptions.find(
      (option) => option.label === platformLabel,
    );
    if (foundPlatformOption) {
      setSelectedPlatformValues(
        selectedPlatformValues.filter(
          (item) => item !== foundPlatformOption.value,
        ),
      );
    }
  };

  const selectedPlatformLabels = selectedPlatformValues.map(
    (platformValue) =>
      socialPlatformOptions.find((option) => option.value === platformValue)
        .label,
  );

  return (
    <div className="audience-search__field" data-qa="filter_social_platform">
      <div className="idh-label idh-label--with-tooltip mb-12">
        <IDHFormattedMessage
          id="front_creator_has_account_on"
          defaultMessage="Social Platform"
        />
        <MaterialTooltip
          id="front_creator_has_account_on_tooltip"
          content={
            <IDHFormattedMessage
              id="front_creator_has_account_on_tooltip"
              defaultMessage="Here you can specify socials the creator has accounts on."
            />
          }
        />
      </div>

      <div className="social-platform-tags">
        <SelectTags
          feed={socialPlatformLabels}
          values={selectedPlatformLabels}
          clearValues={() => setSelectedPlatformValues([])}
          setValue={handleSetPlatform}
          unsetValue={handleUnsetPlatform}
          isExpandable={isExpandable}
        />
        {children}
      </div>
    </div>
  );
}
